import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { initializeApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier, signOut, onAuthStateChanged, signInWithPhoneNumber } from 'firebase/auth';
import { getFirestore, collection, doc, getDoc, addDoc, query, where, getDocs, updateDoc, deleteDoc, limit, startAfter,onSnapshot,orderBy } from 'firebase/firestore';

// Firebase Configuration (store in environment variables for production)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY, // Use env variables for production
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and Firestore
const auth = getAuth(app);
const db = getFirestore(app);

// Export Firebase utilities
export { app, auth, signOut, db, collection, doc, addDoc, RecaptchaVerifier, getDoc, query, where, getDocs,onSnapshot, updateDoc, deleteDoc, limit, startAfter, onAuthStateChanged,orderBy, signInWithPhoneNumber };

// Render the App component
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();



// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './styles/index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { initializeApp } from 'firebase/app';
// import { getAuth, Auth ,RecaptchaVerifier,signOut,onAuthStateChanged, signInWithPhoneNumber} from 'firebase/auth';
// import { getFirestore, collection, doc, getDoc,addDoc, query, where, getDocs,Firestore,updateDoc,deleteDoc,limit, startAfter } from 'firebase/firestore'; 

// // Your Firebase configuration (store these values in environment variables)

// const firebaseConfig = {
//   apiKey: "AIzaSyCCJRIbFN8KBMFq3BsTWVoidywoJinid6w",
//   authDomain: "invoicelypro.magnaopussoftware.in",
//   projectId: "invoicelypro",
//   storageBucket: "invoicelypro.firebasestorage.app",
//   messagingSenderId: "305115119147",
//   appId: "1:305115119147:web:85f3ed6631571a5e28f46e",
//   measurementId: "G-3L2F250YPC"
// };

// // const firebaseConfig = {
// //   apiKey: process.env.REACT_APP_API_KEY,
// //   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
// //   projectId: process.env.REACT_APP_PROJECT_ID,
// //   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
// //   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
// //   appId: process.env.REACT_APP_APP_ID,
// //   measurementId: process.env.REACT_APP_MEASUREMENT_ID
// // };


// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const auth: Auth = getAuth(app);
// const db: Firestore = getFirestore(app);

// export { app, auth,signOut, db, collection, doc,addDoc,RecaptchaVerifier, getDoc, query, where, getDocs , updateDoc,deleteDoc, limit, startAfter,onAuthStateChanged,signInWithPhoneNumber};

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// reportWebVitals();
